import {decode as base64_decode, encode as base64_encode} from 'base-64';
import RootStore from './RootStore';
import config from "../config";
import { postApi,baseURL} from '../components/Utility'
import {
  action,
  
  makeObservable,
  observable,
 
} from 'mobx';


class RMSReportStore {
  RmsReport=[]
  total=0
  loading=false
  rootStore

  constructor(rootStore) {
    makeObservable(this, {
      RmsReport: observable,
      total:observable,
      loading:observable,
      loadData:action,
      exportExcel:action,
      exportpdf:action,
      exportcsv:action,
      exportxml:action
    });
     this.rootStore = rootStore;
    
  }

  async loadData({offset,limit,companyId,eventCode,fromDate,toDate,vehicleId}) {
    this.loading=true;
    var postData = {"companyId":companyId,"vehicleId":vehicleId,"eventCode":eventCode,"fromDate":fromDate,"toDate":toDate,"offset":offset,"limit":limit,"page":1}
    console.log("event Report")
    if(config.pythonReport == 1){
      var response = await postApi.getClient('report').post("/miscellaneous_report/RmsReport", postData);
        // var response = await postApi.getClient('report').post("http://127.0.0.1:5000/miscellaneous_report/RmsReport", postData);
    }
    // console.log("event " ,response?.data?.data)
   
    this.RmsReport =response?.data?.data?.RMSdata
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading=false;

  }

  async exportExcel(getData) {
    // console.log("getData", getData);

    if (config.pythonReport === 1) {
        try {
          await postApi.getClient("report").post("/miscellaneous_report/RmsReport/download/pdf", getData, {
            responseType: "blob",
          });
          this.pythonReportMessage = true;
        } catch (error) {
          this.pythonReportErrorMessage = true;
        }
    
    }
  }

  async exportpdf(getData) {

    if (config.pythonReport === 1) {
      
      try {
          await postApi.getClient("report").post("/miscellaneous_report/RmsReport/download/pdf", getData, {
            responseType: "blob",
          });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
      }
    }else{
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exporteventpdf&cid=" +
        getData.companyId +
        // " &userId=" +
        // 1 +
        "&vid=" +
        getData.vehicleId +
        // "&int=" +
        // getData.interval +
        "&eventCode=" +
        getData.eventCode +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async exportcsv(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exporteventcsv&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      // "&int=" +
      // getData.interval +
      "&eventCode=" +
      getData.eventCode +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
  async exportxml(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exporteventxml&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      // "&int=" +
      // getData.interval +
      "&eventCode=" +
      getData.eventCode +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
  

  
  

}

export default RMSReportStore;
